import {React, useEffect, useState} from "react";
import Sidebar from "../../../layout/Sidebar";
import Header from "../../../layout/Header";
import Footer from "../../../layout/Footer";
import { useForm } from "react-hook-form";
import { memberEnquiryColumns } from "../../../tables/memberEnquiryColumns";
import AdminDataTable from "../../../components/common/AdminDataTable";

export const MemberEnquiry = () => {
    const PAGE_SIZE = 10; 
    const { register, handleSubmit } = useForm();

    const [enquiries, setEnquiries] = useState([]);
    const [loading, setLoading] = useState(false);
    const [totalPages, setTotalPages] = useState(1);
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(PAGE_SIZE);

   
    const [sortBy, setSortBy] = useState("createdAt");
    const [sortOrder, setSortOrder] = useState("desc");

    const API_URL = process.env.REACT_APP_BASE_URL_API || "";
    const token = localStorage.getItem("adminToken");
    
    const fetchEnquiries = async (search = null, page = 1, limit = null) => {
        setLoading(true);
        const usedLimit = limit || pageSize || PAGE_SIZE;
        try {
             const url = `${API_URL.replace(/\/$/, "")}/api/admin/member-enquiry?page=${page}&limit=${usedLimit}${
                        search ? `&name=${encodeURIComponent(search.name || "")}&mobile=${encodeURIComponent(search.mobile || "")}` : ""
                        }`;

             
             const response = await fetch(url, {
                method: "GET",
                headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${token}`, 
                            }
                        });

            const result = await response.json();
            if (result.status) {
                setEnquiries(result.data);
                setTotalPages(result.totalPages || 1);
            }

        } catch (error) {
            console.error("Error fetching member enquiries:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchEnquiries(null ,page);
    }
    , [page]);
    
    // search submit handler
    const onSubmit = (search) => {
         fetchEnquiries(search, 1);
    }

    const columns = memberEnquiryColumns( PAGE_SIZE);
      const handleSort = (column) => {
      if (!column) return;
    
      if (sortBy === column) {
        setSortOrder(sortOrder === "asc" ? "desc" : "asc");
      } else {
        setSortBy(column);
        setSortOrder("asc");
      }
    };



    

    return (
        <div class="container body">
            <div class="main_container">
                <Sidebar />
                <Header pageTitle="Members Enquiry" />

                <div className="right_col" role="main">


                    <div className="x_panel">
                        <div className="x_title">
                            <h2>Members Enquiry</h2>
                            <ul className="nav navbar-right panel_toolbox" style={{ minWidth: 1 }}>
                                <li>
                                    <a className="collapse-link">
                                        <i className="fa fa-chevron-up" />
                                    </a>
                                </li>

                                <li>
                                    <a className="close-link">
                                        <i className="fa fa-close" />
                                    </a>
                                </li>
                            </ul>
                            <div className="clearfix" />
                        </div>
                        <div className="x_content">
                            <div className="row">
                                <div className="col-sm-12">
                                    {/* filter start */}
                                    <div className="filtercont">
                                         <form onSubmit={handleSubmit(onSubmit)}>
                                            <div className="row">
                                                <div className="col-lg-9">
                                                    <div className="row">
                                                        <div className="col-12 col-sm-4 pr-lg-0">
                                                            <label> Search By Name </label>
                                                            <input type="text" {...register("name")} className="form-control" />
                                                        </div>
                                                        
                                                        <div className="col-12 col-sm-4 pr-lg-0">
                                                            <label>Email / Mobile</label>
                                                            <input  type="text" {...register("mobile")} className="form-control" />
                                                        </div>

                                                        <div className="col-12 col-sm-4 pr-lg-0">
                                                            <label>&nbsp;</label>
                                                            <button className="btn btn-default submit sitebtn" >
                                                                Search
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            
                                            </div>
                                        </form>
                                    </div>
                                    {/* filter end */}
                                  <AdminDataTable
                                    columns={columns}
                                    data={enquiries}
                                    page={page}
                                    pageSize={PAGE_SIZE}
                                    totalPages={totalPages}
                                    loading={loading}
                                    onPageChange={setPage}
                                    onPageSizeChange={(size) => {
                                        setPageSize(size);
                                        setPage(1);         
                                        fetchEnquiries(null, 1, size); 
                                    }}
                                    sortBy={sortBy}
                                    sortOrder={sortOrder}
                                    onSort={handleSort}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* bod card end */}
                </div>

                {/* page end */}
                <Footer />

            </div>
        </div>
    );
};
export default MemberEnquiry;
